<template>
    <path d="M28 11C28 6.02944 23.9706 2 19 2" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M25 10.5C25 7.46243 22.5376 5 19.5 5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M3.57666 7.53931C2.5694 9.47221 2 11.6696 2 14.0001C2 21.732 8.26801 28.0001 16 28.0001C18.272 28.0001 20.4175 27.4589 22.3148 26.4984" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M4.25 22.5L2.60454 24.5942C1.97431 25.3963 2.04286 26.5429 2.76416 27.2642V27.2642C3.47328 27.9733 4.59591 28.0531 5.39819 27.4514L8 25.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M20 10L16.5 13.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5 27.5C25.3284 28.3284 26.6716 28.3284 27.5 27.5V27.5C28.3284 26.6716 28.3284 25.3284 27.5 24.5L5.5 2.5C4.67157 1.67157 3.32843 1.67157 2.5 2.5V2.5C1.67157 3.32843 1.67157 4.67157 2.5 5.5L24.5 27.5Z" stroke="white" stroke-width="2" stroke-linecap="round"/>
</template>

<script>
    export default {
        name: 'icon-lx-terminals'
    }
</script>